import { Component, type CSSProperties } from 'react'
import NextStepSection from '../components/NextStepSection'

interface OnboardingStartProps {
  fields: any
  formId: string
  goToNextStep: () => void
  home?: { name?: string }
  mixpanel?: any // Add the correct type for mixpanel
}

export default class OnboardingStart extends Component<OnboardingStartProps> {
  componentDidMount() {
    const { mixpanel } = this.props
    if (mixpanel) mixpanel.track(`CO_start_emar_onboarding`)
  }

  render() {
    const { goToNextStep, home = {} } = this.props
    return (
      <div style={styles.container as CSSProperties}>
        <div style={styles.topText}>
          Congratulations - you’ve started your 30 free trial of eMar. Let's
          customise it for {home.name || 'your care service'} now
        </div>
        <img
          alt=""
          src="https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/emar-onboarding-app.png"
          style={{ maxHeight: 360 }}
        />
        <div style={styles.bottomText}>
          Don’t worry you can always update your settings at a later date.
        </div>
        <NextStepSection
          onNext={() => goToNextStep()}
          label="Start Set Up"
          showText={false}
        />
      </div>
    )
  }
}

const styles = {
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    maxWidth: 960,
    height: '100%',
    padding: '16px',
    marginTop: 16
  },
  topText: {
    marginBottom: 32
  },
  bottomText: {
    marginTop: 32,
    fontSize: 12
  }
}
